import { useQuery } from '@apollo/client';

import { LOCATION_BY_GOOGLE_PLACE_ID } from '../locationByGooglePlaceId';

interface LocationByGooglePlaceIdResult {
  locationByGooglePlaceId: {
    id: string;
    hub: string;
    address: {
      formattedAddress: string;
      countryCode: string;
      originalAddress: string;
    };
    position: {
      lat: number;
      lng: number;
    };
  };
}

interface QueryLocationByGooglePlaceByIdOptions {
  variables: {
    id: string;
  };
  skip: boolean;
}

export const useQueryLocationByGooglePlaceById = (options?: QueryLocationByGooglePlaceByIdOptions) => {
  return useQuery<LocationByGooglePlaceIdResult>(LOCATION_BY_GOOGLE_PLACE_ID, {
    ...options,
    fetchPolicy: 'cache-first',
  });
};
